"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioCardGroup = RadioCardGroup;
exports.RadioCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Form = require("../../../../domains/registration/onboarding/shared/styles/Form");

var _motion = require("../../../../style/motion");

var _Radio = require("./Radio.styled");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;
var borderRadius = '12px';
var textSizeMap = {
  md: function md(theme) {
    return theme.typography.bodyMedium;
  },
  lg: function lg(theme) {
    return theme.typography.titleSM;
  }
};

var DecoratorSelector = _styledComponents["default"].span.withConfig({
  displayName: "RadioCard__DecoratorSelector",
  componentId: "q8qexm-0"
})([""]);

var Fieldset = _styledComponents["default"].fieldset.withConfig({
  displayName: "RadioCard__Fieldset",
  componentId: "q8qexm-1"
})(["border:none;margin:0;padding:0;"]); // Do not use <label>, to support passing form inputs as child


var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "RadioCard__Wrapper",
  componentId: "q8qexm-2"
})(["position:relative;display:flex;align-items:center;border-radius:", ";background-color:var(--colors-blank);cursor:pointer;flex-direction:", ";", " ", " & + &{margin-top:20px;}&:hover ", "{border-color:", ";}"], borderRadius, function (_ref) {
  var theme = _ref.theme;
  return theme.hasSuffix ? 'row' : 'row-reverse';
}, function (_ref2) {
  var theme = _ref2.theme;

  switch (theme.size) {
    case 'md':
      return (0, _styledComponents.css)(["--padding-side:20px;padding:18px var(--padding-side);"]);

    case 'lg':
      return (0, _styledComponents.css)(["--padding-side:32px;padding:28px var(--padding-side);"]);

    default:
      return null;
  }
}, function (_ref3) {
  var theme = _ref3.theme;

  switch (theme.variant) {
    case 'solid':
      return (0, _styledComponents.css)(["box-shadow:0px 12px 60px ", ";"], theme.colors.bayoux_15);

    case 'outline':
      return (0, _styledComponents.css)([""]);

    default:
      return null;
  }
}, DecoratorSelector, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.irisBlue_60;
});

var Content = _styledComponents["default"].span.withConfig({
  displayName: "RadioCard__Content",
  componentId: "q8qexm-3"
})(["position:relative;flex-grow:1;", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.hasSuffix ? (0, _styledComponents.css)(["padding-left:24px;"]) : (0, _styledComponents.css)(["padding-right:24px;"]);
});

var Text = _styledComponents["default"].label.withConfig({
  displayName: "RadioCard__Text",
  componentId: "q8qexm-4"
})(["display:flex;align-items:center;", ";color:var(--colors-darkBlue);"], function (_ref6) {
  var theme = _ref6.theme;
  return textSizeMap[theme.size](theme);
});

var Description = _styledComponents["default"].span.withConfig({
  displayName: "RadioCard__Description",
  componentId: "q8qexm-5"
})(["", ";color:var(--colors-lynch);"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.bodySM;
});

var Suffix = _styledComponents["default"].span.withConfig({
  displayName: "RadioCard__Suffix",
  componentId: "q8qexm-6"
})(["position:relative;"]);

var Input = (0, _styledComponents["default"])(_formik.Field).withConfig({
  displayName: "RadioCard__Input",
  componentId: "q8qexm-7"
})(["position:absolute;opacity:0;&:not(:checked){left:0;height:100%;width:100%;z-index:1;cursor:pointer;}"]);
var RadioStateInCard = (0, _styledComponents["default"])(_Radio.RadioState).withConfig({
  displayName: "RadioCard__RadioStateInCard",
  componentId: "q8qexm-8"
})(["position:relative;flex-shrink:0;"]);
var Decorator = (0, _styledComponents["default"])(DecoratorSelector).withConfig({
  displayName: "RadioCard__Decorator",
  componentId: "q8qexm-9"
})(["position:absolute;top:0;left:0;width:100%;height:100%;border-radius:", ";", " ", " ", ":checked ~ &{border-color:", ";}", ":focus-within ~ &{border-color:", ";}"], borderRadius, (0, _motion.sharedTransition)('border-color'), function (_ref8) {
  var theme = _ref8.theme;

  switch (theme.variant) {
    case 'solid':
      return (0, _styledComponents.css)(["border:2px solid transparent;"]);

    case 'outline':
      return (0, _styledComponents.css)(["border:1.5px solid var(--colors-geyser);", ":checked ~ &{background-color:var(--colors-linkWater);}"], Input);

    default:
      return null;
  }
}, Input, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.irisBlue_60;
}, Input, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.irisBlue_60;
});
var Error = (0, _styledComponents["default"])(_Form.FormFieldError).withConfig({
  displayName: "RadioCard__Error",
  componentId: "q8qexm-10"
})(["margin:12px 0 0 12px;"]);
var RadioCard = /*#__PURE__*/(0, _react.forwardRef)(function RadioCard(_ref11, ref) {
  var label = _ref11.label,
      description = _ref11.description,
      suffix = _ref11.suffix,
      size = _ref11.size,
      margin = _ref11.margin,
      variant = _ref11.variant,
      children = _ref11.children,
      id = _ref11.id,
      props = (0, _objectWithoutProperties2["default"])(_ref11, ["label", "description", "suffix", "size", "margin", "variant", "children", "id"]);
  return __jsx(_styledComponents.ThemeProvider, {
    theme: {
      size: size,
      margin: margin,
      variant: variant,
      hasSuffix: !!suffix
    }
  }, __jsx(Wrapper, null, __jsx(Input, (0, _extends2["default"])({
    id: id,
    type: "radio",
    innerRef: ref
  }, props)), __jsx(Decorator, null), __jsx(RadioStateInCard, null), __jsx(Content, null, __jsx(Text, {
    htmlFor: id
  }, label), description && __jsx(Description, null, description), children), __jsx(Suffix, null, suffix)));
});
exports.RadioCard = RadioCard;
RadioCard.defaultProps = {
  size: 'md',
  variant: 'outline'
};

function RadioCardGroup(_ref12) {
  var name = _ref12.name,
      children = _ref12.children;
  return __jsx(Fieldset, null, children, __jsx(Error, {
    name: name
  }));
}